import AppLogoIcon from "./app-logo-icon"

export default function AppLogo() {
  return (
    <>
      <div className="bg-red shadow-red-glow flex aspect-square size-9 items-center justify-center rounded-md">
        <AppLogoIcon className="size-6 text-white" />
      </div>
      <span className="text-bone font-display ml-2 text-2xl tracking-wide">
        {import.meta.env.VITE_APP_NAME ?? "TODOORDIE"}
      </span>
    </>
  )
}
